import { snakeCase } from "./strings";

interface FieldError {
  field: string;
  messages: string[];
}

/** Shape antd's `form.setFields()` expects. */
export interface FormFieldData {
  name: string;
  value: unknown;
  errors: string[];
}

function buildFieldData(
  data: FieldError[] | undefined,
  values: Record<string, unknown>,
  matchField: (key: string) => string,
): FormFieldData[] {
  if (!data || data.length === 0) return [];

  let fieldData: FormFieldData[] = [];
  for (const key in values) {
    const error = data.find((item: FieldError) => {
      return item.field === matchField(key) && item.messages.length > 0;
    });

    fieldData = [
      ...fieldData,
      {
        name: key,
        value: values[key],
        errors: error?.messages || [],
      },
    ];
  }

  return fieldData;
}

export function getFormError(
  data: FieldError[] | undefined,
  values: Record<string, unknown>,
): FormFieldData[] {
  return buildFieldData(data, values, key => key);
}

export function getFormSnakeCaseError(
  data: FieldError[] | undefined,
  values: Record<string, unknown>,
): FormFieldData[] {
  return buildFieldData(data, values, snakeCase);
}

/** Shape antd's `form.setFields()` expects for a Form.List entry. */
export interface FormListFieldData {
  name: (string | number)[];
  value: unknown;
  touched?: boolean;
  errors?: string[];
}

interface GetFormListErrorsInputProps {
  data: FieldError[] | undefined;
  values: Record<string, unknown>;
  formList: string;
  formListIndex: number;
}

export function getFormListErrorsInput({
  data,
  values,
  formList,
  formListIndex,
}: GetFormListErrorsInputProps): FormListFieldData[] {
  if ((data?.length ?? 0) === 0) return [];

  let fieldData: FormListFieldData[] = [];
  for (const prop in values) {
    const error = data!.find((item: FieldError) => {
      return item.field === prop && item.messages.length > 0;
    });
    fieldData = [
      ...fieldData,
      {
        name: [formList, formListIndex, prop],
        value: values[prop],
        touched: true,
        errors: error ? error.messages : [],
      },
    ];
  }

  return fieldData;
}
